export default {
  namespaced: true,
  state: {
    caches: ["home", "tg_business", "tg_business.reward-record"],
  },
  mutations: {
    ADD_CACHE(state, view) {
      if (state.caches.includes(view.name)) {
        return;
      }
      state.caches.push(view.name);
    },
  },
  actions: {
    addCache({ commit }, view) {
      commit("ADD_CACHE", view);
    },
  },
};
